import { styled } from '@mui/material/styles';
import { ContentRow as ContentRowBase } from '../../styles';
import { ListItem } from '@mui/material';

export const Wrapper = styled(ListItem)``;

export const ContentRow = styled(ContentRowBase)``;

export const OptionLabel = styled(ContentRowBase)``;
